import { createFileRoute } from '@tanstack/react-router'
import About from '@/components/About'
import { usePageSEO } from '@/hooks/usePageSEO'
export const Route = createFileRoute('/about')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageSEO({
    title: 'A propos de JeridSchool - Gestion scolaire pour la Tunisie',
    description:
      'Decouvrez JeridSchool, une plateforme locale pour aider les etablissements tunisiens a gerer administration, enseignants, eleves et parents.',
    keywords:
      'JeridSchool Tunisie, logiciel scolaire tunisien, gestion ecole privee, plateforme educative Tunisie',
    path: '/about',
  })

  return <About />
}
